module.exports = function() {
  return new Worker(__webpack_public_path__ + "9834aab1aef62bdd9edc.worker.js");
};